import React, { useEffect, useState, useContext } from "react";
import { Button, Flex, Spin, Modal, Checkbox } from "antd";
import moment from "moment";
import { instance } from "utils/axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import logo from "assets/images/logo.jpg";
import { AuthContext } from "contexts";

const C = { purple: "#5c1090", yellow: "#f2cd30" };

function Payment() {
  const { state } = useContext(AuthContext);
  const profile = state.studentInfo?.profile;
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [childName, setChildName] = useState(null);
  // Олон хүүхэдтэй эцэг эх: сонгосон хүүхдийн id query-ээр ирнэ;
  // параметргүй үед хуучин шигээ ажиллана
  const [searchParams] = useSearchParams();
  const applicantId = searchParams.get("applicantId");
  const childQ = applicantId ? `?applicantId=${applicantId}` : "";
  const name = childName || profile?.firstName;

  // Суудал баталгаажуулалтын modal
  const [agreementOpen, setAgreementOpen] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [fullName, setFullName] = useState("");
  const [pendingGuid, setPendingGuid] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setLoading(true);
    instance({ method: "get", url: `/applicant/tuition${childQ}` })
      .then((res) => setData(res.data))
      .catch(() => { })
      .finally(() => setLoading(false));
    if (applicantId) {
      instance({ method: "get", url: "/applicant/children" })
        .then((res) => {
          const c = (res.data || []).find((x) => String(x.id) === String(applicantId));
          if (c) setChildName(c.firstName);
        })
        .catch(() => { });
    }
  }, []);

  const handleSeatConfirmClick = (guid) => {
    setPendingGuid(guid);
    setAgreed(false);
    setFullName("");
    setAgreementOpen(true);
  };

  const handleAgreementOk = async () => {
    if (!agreed || !fullName.trim() || !pendingGuid) return;
    setSaving(true);
    try {
      await instance({
        method: "put",
        url: `/applicant/tuition-schedule/${pendingGuid}/agree`,
        data: { fullName: fullName.trim() },
      });
    } catch (e) {
      console.log(e);
    } finally {
      setSaving(false);
      setAgreementOpen(false);
      // Safari: await-ийн дараах window.open-ийг popup blocker хаадаг тул
      // шинэ таб биш, өөр дээрээ шилжинэ
      navigate(`/payment/qpay/${pendingGuid}`);
    }
  };

  const seatConfirm = data?.tuition_schedules?.find(s => s.type === "SeatConfirm");
  // partial-г төлсөнтэй адил тооцно — дахин бүтэн дүнгээр Qpay явахаас сэргийлнэ
  const isSeatPaid = seatConfirm?.status === "PAID" || seatConfirm?.status === "partial";

  return (
    <div className="flex flex-col items-center h-screen relative font-raleway">
      <div className="md:mt-16 w-full flex justify-center">
        {loading ? (
          <div className="flex flex-col items-center mt-20">
            <Flex align="center" gap="middle">
              <Spin size="large" />
            </Flex>
          </div>
        ) : !data ? (
          <div className="gap-4 mx-auto py-10">
            Мэдээлэл олдсонгүй
          </div>
        ) : (
          <div className="m-8 md:w-4/5 w-full">
            <div className="gap-4 mx-auto py-10 md:py-0 md:mb-8">
              <div className="text-[20pt] xl:text-[30pt] font-extrabold text-primary leading-[1.38]">
                Сайн уу {name},
              </div>
              <div className="mb-8 mt-8 leading-[1.38]">
                Томүжин Алтернатив сургуулийн өргөдөл, бататгах сорил, ярилцлага
                гээд үе шатуудыг амжилттай давж тэнцсэнд нь дахин баяр хүргэе!
                <br /><br />
                Дараах хүснэгтээс сургалтын төлбөр, санхүүгийн дэмжлэгийн
                мэдээллийг авна уу.
              </div>

              {/* ── Сургалтын төлбөр ── */}
              <div className="font-bold text-primary">Сургалтын төлбөр</div>
              <div className="border-t-2 border-primary p-2 italic">
                <b style={{ color: "red" }}>*</b> Сургалтын төлбөр нь тухайн
                хичээлийн жилд сурагчид зориулсан сургалтын нийт үйл ажиллагааны
                төлбөр юм. Үүнд сурагчийн зорчих унааны төлбөр, өдрийн хоол,
                сурах бичиг болон хичээлээс гадуурх үйл ажиллагааны төлбөр
                багтаагүй болно.
              </div>

              <div className="p-2 flex justify-between text-[10pt] md:text-[12pt]">
                <div>Нийт сургалтын төлбөр</div>
                <div className="font-bold">
                  ₮{Number(data.tuitionAmount ?? 0).toLocaleString()}
                </div>
              </div>

              {data.finAid > 0 && (
                <div className="p-2 flex justify-between text-[10pt] md:text-[12pt]">
                  <div>Санхүүгийн дэмжлэг ({data.finAidPercent}%)</div>
                  <div className="font-bold" style={{ color: "green" }}>
                    -₮{Number(data.finAid ?? 0).toLocaleString()}
                  </div>
                </div>
              )}
              {data.discount > 0 && (
                <div className="p-2 flex justify-between text-[10pt] md:text-[12pt]">
                  <div>
                    Хөнгөлөлт
                    {data.discountReason ? ` (${data.discountReason})` : ""}
                  </div>
                  <div className="font-bold" style={{ color: "green" }}>
                    -₮{Number(data.discount ?? 0).toLocaleString()}
                  </div>
                </div>
              )}
              {(data.finAid > 0 || data.discount > 0) && (
                <div className="mt-1 border-t-4 text-primary border-b-4 p-2 flex justify-between border-primary">
                  <div className="font-bold text-primary">Таны төлөх нийт төлбөр</div>
                  <div className="font-bold text-primary">
                    ₮{Number(
                      (data.tuitionAmount ?? 0) -
                        (data.finAid ?? 0) -
                        (data.discount ?? 0)
                    ).toLocaleString()}
                  </div>
                </div>
              )}

              {/* ── Төлбөрийн хуваарь ── */}
              <div className="font-bold text-primary mt-14">Төлбөрийн хуваарь</div>
              <div className="border-t-2 border-primary p-2 italic">
                <b style={{ color: "red" }}>*</b> Таны төлөх төлбөр нь дараах
                хуваарийн дагуу төлөгдсөн байх шаардлагатай.
              </div>
            </div>

            <div className="border-b-4 border-primary p-2 flex justify-between font-bold">
              <div className="text-left w-60">Төлбөр төлөх ээлж</div>
              <div className="text-center">Төлөх эцсийн хугацаа</div>
              <div className="text-right">Төлөх дүн</div>
            </div>

            {data.tuition_schedules?.map((el) => (
              <div key={el.id}>
                <div className="flex p-2 justify-between text-[10pt] md:text-[12pt]">
                  <div className="text-left w-60">{el.title ?? "Төлбөр"}</div>
                  <div className="text-center">
                    {moment(el.payDate).format("YYYY оны M сарын DD")}
                  </div>
                  <div className="text-right">
                    ₮{Number(el.amount ?? 0).toLocaleString()}{" "}
                    {el.status === "PAID" ? (
                      <span style={{
                        background: "#dcfce7", color: "#166534",
                        borderRadius: 4, padding: "2px 8px", fontSize: 12, fontWeight: 600,
                      }}>
                        Төлсөн ✓
                      </span>
                    ) : el.status === "partial" ? (
                      <span style={{
                        background: "#fef3c7", color: "#92400e",
                        borderRadius: 4, padding: "2px 8px", fontSize: 12, fontWeight: 600,
                      }}>
                        Хэсэгчилсэн төлсөн · үлдсэн ₮{Number((el.amount || 0) - (el.paidAmount || 0)).toLocaleString()}
                      </span>
                    ) : el.type === "SeatConfirm" ? (
                      !isSeatPaid && (
                        <Button
                          size="small"
                          style={{ backgroundColor: C.yellow, color: C.purple, fontWeight: 700 }}
                          onClick={() => handleSeatConfirmClick(el.guid)}
                        >
                          Суудал баталгаажуулах
                        </Button>
                      )
                    ) : (
                      isSeatPaid && (
                        <Button
                          size="small"
                          style={{ backgroundColor: C.yellow, color: C.purple, fontWeight: 700 }}
                          onClick={() => navigate(`/payment/qpay/${el.guid}`)}
                        >
                          Төлөх
                        </Button>
                      )
                    )}
                  </div>
                </div>
                <div className="border-b-4 border-primary" />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Суудал баталгаажуулалтын Modal ── */}
      <Modal
        open={agreementOpen}
        onCancel={() => setAgreementOpen(false)}
        footer={null}
        centered
        width={560}
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ fontFamily: "'Raleway','Segoe UI',sans-serif", borderRadius: 8, overflow: "hidden" }}>

          {/* Контент */}
          <div style={{ padding: "28px 32px 24px", borderBottom: "1px solid #f0eaff" }}>
            <img src={logo} alt="Томүжин" style={{ width: 110, marginBottom: 20, display: "block" }} />

            <div style={{ fontWeight: 700, color: C.purple, fontSize: 16, marginBottom: 16 }}>
              СУУДАЛ БАТАЛГААЖУУЛАЛТЫН НӨХЦӨЛ
            </div>

            {/* Нөхцөлүүд */}
            <div style={{
              background: "#faf5ff", border: "1.5px solid #d8b4fe",
              borderRadius: 8, padding: "16px 20px", marginBottom: 20,
              color: "#3b0764", fontSize: 14, lineHeight: 1.9,
            }}>
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                <li>
                  Суудал баталгаажуулалт нь <strong>2,000,000₮</strong> байх ба
                  тухайн жилийн сургалтын төлбөрт багтана.
                </li>
                <li>
                  Суудал баталгаажуулалт нь сурагчийн тухайн хичээлийн жил
                  суралцах баталгаа бөгөөд сурагчийн орон тоог хадгалж байгаа
                  нөхцөл юм.
                </li>
                <li>
                  Суудал баталгаажуулалт хийгдсний дараа ямар нэгэн шалтгаанаар
                  суралцах боломжгүй болсон тохиолдолд{" "}
                  <strong>буцаан олгогдохгүй</strong> болохыг анхаарна уу.
                </li>
              </ul>
            </div>

            {/* Checkbox */}
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              style={{ color: C.purple, fontWeight: 600, marginBottom: 20 }}
            >
              Дээрх нөхцөлтэй бүрэн танилцаж, хүлээн зөвшөөрсөн болно.
            </Checkbox>

            {/* Уншиж танилцсан баталгаа — овог нэр бичнэ */}
            <div>
              <div style={{ fontSize: 13, color: C.purple, fontWeight: 600, marginBottom: 6 }}>
                Уншиж танилцсан хүний овог, нэр
              </div>
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Овог Нэр"
                style={{
                  width: "100%", padding: "9px 12px", fontSize: 14,
                  border: "1.5px solid #d8b4fe", borderRadius: 6,
                  outline: "none", color: "#3b0764",
                  background: "#fff", boxSizing: "border-box",
                }}
              />
            </div>
          </div>

          {/* Footer */}
          <div style={{
            padding: "16px 32px", display: "flex",
            justifyContent: "flex-end", gap: 12,
            background: "#fafafa", borderTop: "1px solid #f0eaff",
          }}>
            <Button onClick={() => setAgreementOpen(false)}>
              Болих
            </Button>
            <Button
              type="primary"
              loading={saving}
              disabled={!agreed || !fullName.trim()}
              onClick={handleAgreementOk}
              style={{
                background: agreed && fullName.trim() ? C.purple : undefined,
                borderColor: agreed && fullName.trim() ? C.purple : undefined,
                fontWeight: 700,
              }}
            >
              Зөвшөөрч, төлбөр төлөх →
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Payment;